import React, { ReactNode } from 'react'
import { Box, ButtonBase, SxProps, styled } from '@mui/material'

const Wrapper = styled(Box)`
  display: flex;
  padding: 4px;
  column-gap: 4px;
  background: #344204;
`

const LinkButton = styled(ButtonBase)<{ isactive?: string; width?: string }>`
  width: ${({ width }) => width || 'auto'};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;

  background: ${({ isactive }) => (isactive === 'true' ? '#bfff0b' : 'transparent')};
  border: 1px solid transparent;

  color: ${({ isactive }) => (isactive === 'true' ? '#000' : 'rgba(255,255,255,0.5)')};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.01em;
  font-feature-settings: 'ss01' on, 'ss02' on, 'calt' off;

  :hover {
    border-color: #bfff0b;
    background: transparent;
    color: #bfff0b;
  }
`

interface TabProps {
  isActive: boolean
  onClick?: () => void
  children: ReactNode
  width?: string
}

interface TabsProps {
  children: ReactNode
  wrapperSx?: SxProps
}

export const Tab2 = ({ isActive, onClick, width, children }: TabProps) => {
  return (
    <LinkButton isactive={isActive ? 'true' : 'false'} width={width} onClick={onClick}>
      {children}
    </LinkButton>
  )
}

export const Tabs2 = ({ children, wrapperSx }: TabsProps) => {
  return <Wrapper sx={wrapperSx}>{children}</Wrapper>
}
